import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const sendNotification = async (formData) => {
    const token = await cookie.get("token");
    return await axios.post(`${proxy}/notification/create`, formData, {
        headers: { Authorization: token }
    });
};